import React from 'react'

import Store from './Store';
import StoreAdder from './StoreAdder';

const StoreList = (props) => {

    const removeStoreFromModule = (storeGln) => {
        props.removeStoreFromModule(storeGln, props.module.name);
    };

    return (
        <div className="card">
            <div className="card-header">Zugeordnete Stores für {props.module.name}</div>
            <div className="card-body">
                <div className="row">
                    <div className="col-lg-5">
                        <StoreAdder stores={props.storesNotInModule} module={props.module.name} onAdd={props.addStoreToModule} />
                    </div>
                    <div className="col-lg-7">
                    </div>
                </div>
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>Händler-GLN</th>
                        <th>Filial-GLN</th>
                        <th>Name</th>
                        <th>Straße</th>
                        <th>PLZ</th>
                        <th>Ort</th>
                        <th>Aktionen</th>
                    </tr>
                    </thead>
                    <tbody>
                    {props.stores.map((store) => <Store {...store} removeStoreFromModule={removeStoreFromModule}/>)}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default StoreList;



// WEBPACK FOOTER //
// ./src/admin/module/overview/StoreList.js